import React from 'react';
import PropTypes from 'prop-types';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import SearchBar from '../../searchbar/SearchBar';
import PayableReminderService from '../../../service/PayableReminderService';
import PRSDetailModal from './PRSDetailModal';

class PRSView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      selectedLog: null,
    };
    this.searchBar = React.createRef();
    this.comboFields = [
      {
        value: 'serviceOfferingId',
        display: 'Service Offering ID',
      },
      {
        value: 'accountId',
        display: 'Account Id',
      },
      {
        value: 'billId',
        display: 'Bill Id',
      },
    ];
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  statefulInitialization() {
    const { click, } = this;
    if (click) {
      click();
    }
  }

  getActivityLogs = (searchFields, onCompletion = () => {}) => {
    PayableReminderService.getActivityLogs(searchFields)
      .then(response => response.data)
      .then(response => {
        this.setState({
          logs: response.logs,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        onCompletion();
      });
  };

  reset = () => {
    this.setState({
      logs: [],
      selectedLog: null,
    });
  };

  onSearch = (event) => {
    this.reset();
    const { search, combo, } = event;
    const { requestedState = {}, } = this.props;
    const { id = '', } = requestedState;

    const searchField = {};
    if (id && !search.value) {
      searchField.customerId = id;
    } else {
      searchField[combo.value] = search.value;
    }

    this.getActivityLogs(searchField, event.kill);
  };

  onRowSelect = (row) => {
    this.setState({ selectedLog: row, });
  };

  renderResults = () => {
    const { logs, } = this.state;
    if (!logs) {
      return null;
    }

    const headers = [
      {
        value: 'billId',
        display: 'Bill ID',
      },
      {
        value: 'accountId',
        display: 'Account Id',
      },
      {
        value: 'serviceOfferingId',
        display: 'Service Offering',
      },
      {
        value: '',
        display: 'Click here',
      },
      {
        value: '_id',
        display: 'ID',
      },
    ];

    const rows = logs.map(log => ({
      value: [
        log.billId,
        log.accountId,
        log.serviceOfferingId,
        null,
        log._id,
      ],
    }));

    return (
    <div style={{ marginTop: '20px', }}>
      <FieldSet title='payable reminder activity Logs' style={{ maxHeight: '500px', }}>
        <Grid
          headers={headers}
          rows={rows}
          onRowSelect={this.onRowSelect}
        />
      </FieldSet>
      <div style={{ marginTop: '20px', }}>
        {this.renderActivityLogDetails()}
      </div>
    </div>
    );
  };

  renderActivityLogDetails = () => {
    const { logs, selectedLog, } = this.state;

    if (!selectedLog) {
      return null;
    }

    const rawActivityLogDetails = logs.find(log => log._id === selectedLog._id);

    return (
    <>
      <p>{`Selected Activity Log: ${selectedLog._id}`}</p>
      <hr />
      <PRSDetailModal selectedLog={rawActivityLogDetails} />
    </>
    );
  };

  _setClickEvent(click) {
    this.click = click;
  }

  render() {
    const { serviceOfferingId = '', } = this.state;
    return (
    <div className='container'>
      <SearchBar
        comboFields={this.comboFields}
        defaultText={serviceOfferingId}
        onClick={this.onSearch}
        clickConsumer={click => this._setClickEvent(click)}
      />
      {this.renderResults()}
    </div>
    );
  }
}

PRSView.defaultProps = {
  requestedState: undefined,
};

PRSView.propTypes = {
  requestedState: PropTypes.string,
};

export default PRSView;
